import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from '@nosto/preact'
import { useEffect, useMemo, useRef, useState } from 'preact/hooks'
// import SkeletonProduct from "./SkeletonProduct"
import { getSrcset, productImagePlaceholder, jsonParser } from '../helpers'

export default ({ product, pageType, 
    // groupData
 }) => {
    const { format } = useCurrencyFormatting();

    const badge = useMemo(() => {
        const field = product.customFields.find(field => field.key === 'custom-badge')?.value?.split('* ');
        return (field?.length) ? { type: field[0].toLowerCase(), text: field[1] } : false;
    }, []);

    // const reviews = useMemo(() => {
    //     const reviewData = jsonParser(product.customFields.find(field => field.key === 'reviews-rating')?.value);
    //     const reviewCount = product.customFields.find(field => field.key === 'reviews-rating_count')?.value;
    //     return (!isNaN(reviewData?.value) && !isNaN(reviewCount) && !isNaN(reviewData.scale_max)) 
    //         ? { rating: reviewData.value, count: reviewCount, max: reviewData.scale_max } 
    //         : false
    // }, [])

    const prodElRef = useRef(null);
    const [ activeSwatch, setActiveSwatch ] = useState(null);
    const [ updating, setUpdating ] = useState(false);
    const [ height, setHeight ] = useState(null);

    const prices = useMemo(() => {
        return (activeSwatch) 
            ?   { price: activeSwatch.price, listPrice: activeSwatch.listPrice }
            :   { price: product.price, listPrice: product.listPrice }
    }, [ activeSwatch ]);

    const images = useMemo(() => {
        return (activeSwatch)
            ?   { mainImage: activeSwatch.imageUrl, altImages: activeSwatch.alternateImageUrls }
            :   { mainImage: product.imageUrl, altImages: product.alternateImageUrls }
    }, [ activeSwatch ])

    const url = useMemo(() => {
        if(pageType === 'category') {
            return (activeSwatch) 
                ?   location.pathname + '/products/' + activeSwatch.url.split('/products/')[1]
                :   location.pathname + '/products/' + product.url.split('/products/')[1]
        } else {
            return (activeSwatch) ? activeSwatch.url : product.url
        }
    }, [ pageType, activeSwatch ])

    const title = useMemo(() => {
        const fullName = activeSwatch ? activeSwatch.name : product.name;
        const split = fullName.split(' | ');
        return { fullName, name: split[0], colorway: split[1] }
    }, [ activeSwatch ]);

    // useEffect(() => {
    //     if(!activeSwatch && groupData?.products?.length > 0) {
    //         setActiveSwatch(groupData.products.find(p => p.productId === product.productId))
    //     }
    // }, [ activeSwatch, groupData ])

    // const handleSwatchChange = (swatchProd) => {
    //     if(activeSwatch.productId !== swatchProd) {
    //         setUpdating(true);
    //         if(!height || (prodElRef.current && height < prodElRef.current.offsetHeight)) {
    //             setHeight(prodElRef.current.offsetHeight)
    //         }
    //         setActiveSwatch(swatchProd)
    //         setTimeout(() => {
    //             setUpdating(false);
    //         }, 400)
    //     }
    // }

    return (
        <SerpElement
            as="div"
            hit={product}
            class="ns-product"
        >
            {updating ? (
                <div class="ns-spinner-wrap" style={`min-height: ${height}px;`}>
                    <div class="ns-loading-spinner" />
                </div>
            ) : (
                <product-block 
                    class="product-block" 
                    data-id={activeSwatch ? activeSwatch.productId : product.productId} 
                    ref={prodElRef}
                >
                    <div class="block-inner cc-animate-init cc-animate-in" data-cc-animate="">
                        <div class="block-inner-inner">
                            <div class={`image-cont ${(images.altImages?.length > 0) ? 'image-cont--with-secondary-image image-cont--same-aspect-ratio' : ''}`}>
                                <a class="product-link" href={url} tabindex="-1">
                                    <div class="image-label-wrap">
                                        <div>
                                            <div class="product-block__image product-block__image--primary product-block__image--active">
                                                <div class="img-ar img-ar--cover" style="--aspect-ratio: .8;">
                                                    <img
                                                        class="theme-img"
                                                        srcset={images.mainImage ? getSrcset(images.mainImage) : ''}
                                                        src={images.mainImage ?? productImagePlaceholder}
                                                        sizes="(min-width: 1320px) 330px, (min-width: 768px) 25vw, 50vw"
                                                        alt={title.fullName}
                                                        width="2048"
                                                        height="2048"
                                                        loading="eager"
                                                    />
                                                </div>
                                            </div>
                                            {(images.altImages?.length > 0) && (
                                                images.altImages.map((altImageUrl, index) => (
                                                    <div 
                                                        key={altImageUrl + title.fullName}
                                                        class={`product-block__image product-block__image--secondary ${index === 0 ? 'product-block__image--show-on-hover' : 'product-block__image--inactivated'}`}
                                                    >
                                                        <div class="img-ar img-ar--cover" style="--aspect-ratio: .8;">
                                                            <img
                                                                class="theme-img"
                                                                srcset={getSrcset(altImageUrl)}
                                                                src={altImageUrl}
                                                                sizes="(min-width: 1320px) 330px, (min-width: 768px) 25vw, 50vw"
                                                                alt={title.fullName}
                                                                width="2048"
                                                                height="2048"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                        <div class="product-block__image-dots" aria-hidden="true">
                                            <div class="product-block__image-dot product-block__image-dot--active" />
                                            {(images.altImages?.length > 0) &&
                                                <div class="product-block__image-dot" />
                                            }
                                            {(images.altImages?.length > 1) &&
                                                <div class="product-block__image-dot product-block__image-dot--more" />
                                            }
                                        </div>
                                    </div>
                                </a>
                                {(images.altImages?.length > 0) &&
                                    <>
                                        <a class="image-page-button image-page-button--previous has-ltr-icon" href="#" aria-label="Previous" tabindex="-1">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-left" aria-hidden="true" focusable="false" role="presentation">
                                                <path d="m15 18-6-6 6-6"></path>
                                            </svg>
                                        </a>
                                        <a class="image-page-button image-page-button--next has-ltr-icon" href="#" aria-label="Next" tabindex="-1">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-right" aria-hidden="true" focusable="false" role="presentation">
                                                <path d="m9 18 6-6-6-6"></path>
                                            </svg>
                                        </a>
                                    </>
                                }
                                <a 
                                    class="btn btn--secondary quickbuy-toggle" 
                                    href={url}
                                >
                                    Add to Cart
                                </a>
                            </div>
                            {/* note: non-native styling used on elements below */}
                            <div class="ns-product-block__detail"> 
                                <a 
                                    class="ns-product-link" 
                                    href={url} 
                                    title={title.fullName} 
                                    rel="nofollow"
                                >
                                    <div class="ns-product-block__info">
                                        <div class="ns-product-block__header">
                                            <span class="ns-product-block__name">{title.name}</span>
                                            <div class="ns-product-price">
                                                {(prices.listPrice && prices.listPrice > prices.price) && (
                                                    <div class="ns-price__original">
                                                        <span class="visually-hidden sr-only">Original price:</span>
                                                        <span class="ns-price ns-original-price">
                                                            {format(prices.listPrice).replace('.00', '').replaceAll(' ', '')}
                                                        </span>
                                                    </div>
                                                )}
                                                <div class="ns-price__default">
                                                    <span class="visually-hidden sr-only">Final price:</span>
                                                    <span class="ns-price ns-final-price">
                                                        {format(prices.price).replace('.00', '').replaceAll(' ', '')}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="ns-product-block__colorway">{title.colorway}</span>    
                                        {(badge?.type && badge?.text) && 
                                            <span 
                                                class="ns-product-block__badge"
                                                data-type={badge.type.replaceAll('*', '').trim()}
                                            >
                                                {badge.text}
                                            </span>
                                        }
                                    </div>
                                </a>
                                {/* {reviews && (
                                    <div class="product-block__rating">
                                        <div class="cc-rating" role="img" data-rating-decimal="0" aria-label={`${reviews.rating} out of 5.0 stars`}>
                                            <span aria-hidden="true" class="cc-rating-stars">
                                                <span class="cc-rating-stars--inactive">
                                                    {Array.from({ length: Math.ceil(reviews.max) }).map((_, index) => (
                                                        <svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43579 4.9459L13.63 4.9536L9.42653 8.01929L11.0329 12.97L6.81981 9.91778L2.60673 12.97L4.20346 8.01929L0 4.9536L5.20383 4.9459L6.81981 0L8.43579 4.9459Z"></path>
                                                        </svg>
                                                    ))}
                                                </span>
                                                <span class="cc-rating-stars--active">
                                                    {Array.from({ length: Math.ceil(reviews.rating) }).map((_, index) => (
                                                    <svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43579 4.9459L13.63 4.9536L9.42653 8.01929L11.0329 12.97L6.81981 9.91778L2.60673 12.97L4.20346 8.01929L0 4.9536L5.20383 4.9459L6.81981 0L8.43579 4.9459Z"></path>
                                                    </svg>
                                                    ))}
                                                </span>
                                            </span>
                                        </div>
                                        <p class="cc-rating-text">
                                            <span aria-hidden="true">{reviews.rating} / 5.0</span>
                                        </p>
                                        <span class="cc-rating-custom-caption">{reviews.count} reviews </span>
                                    </div>
                                )} */}

                                {/* {(groupData && groupData.products?.length > 0) && (
                                    <div class="ns-product__swatches-wrap">
                                        <fieldset class="ns-product__swatches-inner">
                                            {groupData.products.map(prod => {
                                                const swatchColor = prod.attributes?.find(attr => attr.key === 'custom-color_name')?.value;
                                                return (
                                                    <div class="ns-swatch" key={product.productId + prod.productId}>
                                                        <div class="ns-swatch__tooltip">{swatchColor}</div>
                                                        <label class="ns-swatch__label">
                                                            <input
                                                                class="visually-hidden sr-only"
                                                                type="radio"
                                                                name={`ns-swatch-${product.productId}-${prod.productId}`}
                                                                checked={activeSwatch?.productId === prod.productId}
                                                                onChange={() => handleSwatchChange(prod)}
                                                            />
                                                            <img
                                                                class="ns-swatch__image"
                                                                src="https://www.appaman.com/cdn/shop/files/Screen_Shot_2023-01-20_at_2.59.57_PM.png?v=1674244808&amp;width=50"
                                                                width="25"
                                                                height="25"
                                                                loading="lazy"
                                                                alt={`Color swatch image for ${title.name}: ${swatchColor}`}
                                                            />
                                                        </label>
                                                    </div>
                                                )
                                            })}
                                        </fieldset>
                                    </div>
                                )} */}
                            </div>
                        </div>
                    </div>
                    <div class="quickbuy-container use-color-scheme use-color-scheme--default">
                        <a href="#" class="close-detail" aria-label="Close" tabindex="-1">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-x" aria-hidden="true" focusable="false" role="presentation"><path d="M18 6 6 18M6 6l12 12"></path></svg>
                        </a>
                        <div class="inner"></div>
                    </div>
                </product-block>
            )}
        </SerpElement>
    )
}